export const siteNav = [
  { to: "/product", label: "Prodotto" },
  { to: "/pricing", label: "Prezzi" },
  { to: "/contact", label: "Demo" },
];

export const audiencePlans = {
  consultants: [
    {
      code: "consultant_trial",
      name: "Trial",
      priceLabel: "Gratis 14 giorni",
      badge: "Per iniziare",
      description: "Per consulenti che vogliono testare il flusso completo di audit multi-framework.",
      ctaLabel: "Inizia prova",
      ctaMode: "signup",
      highlights: ["1 tenant consulente", "3 aziende gestibili", "Checklist e report base", "Setup immediato"],
    },
    {
      code: "consultant_solo",
      name: "Consultant Solo",
      priceLabel: "89 EUR / mese",
      badge: "Consigliato",
      description: "Per freelance e DPO che gestiscono audit ricorrenti su piu clienti.",
      ctaLabel: "Attiva con Stripe",
      ctaMode: "checkout",
      highlights: ["Aziende illimitate", "Audit versionati", "Verbali AI personalizzati", "Export Word e PDF"],
    },
    {
      code: "consultant_studio",
      name: "Studio",
      priceLabel: "229 EUR / mese",
      badge: "Per team",
      description: "Per studi che vogliono standardizzare template, branding e governance clienti.",
      ctaLabel: "Parla con noi",
      ctaMode: "contact",
      highlights: ["Template condivisi", "Branding white-label", "Workflow consulenti", "Onboarding dedicato"],
    },
  ],
  companies: [
    {
      code: "company_growth",
      name: "Company",
      priceLabel: "149 EUR / mese",
      badge: "Licenza annuale",
      description: "Per aziende che vogliono gestire audit interni e collaborare con consulenti esterni.",
      ctaLabel: "Richiedi attivazione",
      ctaMode: "contact",
      highlights: ["Utenti interni inclusi", "Accessi consulenti approvabili", "Storico audit", "Report brandizzati"],
    },
    {
      code: "company_scale",
      name: "Enterprise",
      priceLabel: "Su preventivo",
      badge: "Compliance avanzata",
      description: "Per gruppi con esigenze di governance, onboarding e supporto prioritario.",
      ctaLabel: "Prenota demo",
      ctaMode: "contact",
      highlights: ["Multi-team", "Supporto prioritario", "Roadmap condivisa", "Setup guidato"],
    },
  ],
};

export const homeHighlights = [
  {
    title: "Checklist multi-framework pronte",
    body: "GDPR, NIS2, ISO 27001, DORA e AI Act in un unico workspace operativo.",
  },
  {
    title: "Audit versionati e sempre tracciabili",
    body: "Ogni revisione resta storicizzata, con stato, punteggio e azioni suggerite.",
  },
  {
    title: "Verbali professionali con AI",
    body: "Genera executive summary, gap analysis e remediation plan con output pronti per clienti e management.",
  },
  {
    title: "Consulenti e aziende nello stesso flusso",
    body: "Richieste di accesso, approvazioni e collaborazione senza scambio continuo di file o fogli Excel.",
  },
];

export const workflowSteps = [
  "Selezioni il framework e il perimetro dell'audit.",
  "Compili checklist, evidenze e note operative.",
  "Il sistema calcola score, gap e priorita di intervento.",
  "Esporti report, verbali e deliverable brandizzati.",
];

export const faqItems = [
  {
    q: "Posso usare Audit Pro come consulente esterno?",
    a: "Si. Il prodotto nasce proprio per consulenti compliance, DPO e studi che gestiscono piu aziende.",
  },
  {
    q: "Le aziende possono usare il software in autonomia?",
    a: "Si. Il tenant aziendale consente accessi interni e gestione delle richieste da parte dei consulenti.",
  },
  {
    q: "I piani si attivano con Stripe?",
    a: "Si. Il frontend e predisposto per checkout e gestione abbonamenti via Stripe.",
  },
  {
    q: "Serve installare qualcosa?",
    a: "No, per l'uso cliente l'idea e un accesso web classico. In locale il progetto puo essere avviato anche self-hosted.",
  },
];
